export const BASE_PATH = window.location.origin
const BASE_PATH_API = process.env.NODE_ENV === 'development'
  // ? 'https://latest-minor.dev.crude.docker.3m5.cloud'
  // ? 'https://latest-patch.dev.crude.docker.3m5.cloud'
  // ? 'https://demo.dev.crude.docker.3m5.cloud'
  // ? 'https://crm.devi.3m5.de'
  ? 'http://localhost:8080'
  : BASE_PATH

const devEnv = {
  restBase: BASE_PATH_API,
  crudeRestBase: BASE_PATH_API + '/api/crude/',
}

const stageEnv = {
  ...devEnv,
}

const prodEnv = {
  ...devEnv,
}

type Env = typeof devEnv
  | typeof stageEnv
  | typeof prodEnv

const getEnvValues: () => Env = () => {
  switch (process.env.BUILD_ENV) {
    case 'production':
      return prodEnv
    case 'staging':
      return stageEnv
  }
  return devEnv
}

export const isDebugEnv: boolean = process.env.BUILD_ENV !== undefined
  ? process.env.BUILD_ENV === 'development'
  : process.env.NODE_ENV === 'development'

export default getEnvValues()
